import {
  useMemo, useState 
} from "react"

const defaultInitialPage = 1

export const useReviewPagination = ({
  initialCurrentPage 
}) => {
  const [currentPage, setCurrentPage] = useState(initialCurrentPage || defaultInitialPage)

  const [totalPages, setTotalPages] = useState(defaultInitialPage)

  const paginationState = {
    currentPage,
    totalPages,
  }

  const api = useMemo(
    () => ({
      setCurrentPage,
      setTotalPages,
    }),
    [setCurrentPage, setTotalPages]
  )

  return [paginationState, api]
}
